angular.module('wco.directives.otherPackageSelect', [])
.controller('WcoOtherPackageSelectController', ['$scope','$uibModal', 'packingDaisyService', 'Flash', function($scope, $uibModal, packingDaisyService, Flash) {
    $scope.open = function() {
        packingDaisyService.getPackageSelection($scope.packingSlip).then((response) => {
            if (response.PACKAGES.length > 0){
                let modalScope = $scope.$new(true);
                modalScope.params = {
                    PACKAGES: response.PACKAGES,
                    PACKING_SLIP: $scope.packingSlip
                };

                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'angular/directives/otherPackageSelectModal.html',
                    controller: 'WcoOtherPackageSelectModalController',
                    size: 'lg',
                    backdrop: 'static',
                    scope: modalScope
                });

                modalInstance.result.then(function (message) {
                    $scope.$emit('otherPackageAdded', message);
                }, function () {

                });
            }
            else{
                Flash.create('warning', 'Keine möglichen Packstücke gefunden.');
            }
        });
    };
}])
.directive('wcoOtherPackageSelect', function() {
    return {
        controller: 'WcoOtherPackageSelectController',
        controllerAs: 'WcoOtherPackageSelectController',
        templateUrl: function(element, attrs){
            return attrs.templateUrl || 'angular/directives/otherPackageSelect.html';
        },
        scope:{
            packingSlip: '='
        },
        replace: true
    };
})
.controller('WcoOtherPackageSelectModalController',  ['$scope','$uibModalInstance', 'packingDaisyService', '$timeout', 'Flash', function ($scope, $uibModalInstance, packingDaisyService, $timeout, Flash) {
    let boot = function(){
        $scope.PACKAGES = $scope.params.PACKAGES;
        $scope.PACKING_SLIP = $scope.params.PACKING_SLIP;
        $scope.selectedPackage = false;
    };
    boot();

    $scope.selectPackage = function(selectedPackage){
      $scope.selectedPackage = selectedPackage;
    };

    $scope.confirmSelection = function () {
        packingDaisyService.addPackingSlipToPackage($scope.PACKING_SLIP, $scope.selectedPackage.PACKAGE_NUMBER).then((response) => {
            Flash.create('success', 'Packstück hinzugefügt.')
            $uibModalInstance.close(response);
        });
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}]);